export default "__VITE_ASSET__DFNvcs4d__"